<div class="attachments-container">
    <div class="p-chips">
        <ul class="p-chips-multiple-container">
            <ng-container *ngFor="let attachment of attachments; let i = index">
                <ng-container *ngIf="attachment.attachment">
                    <ng-container *ngIf="attachment.attachment.statusId === 1">
                        <li class="p-chips-token">
                            <ng-container *ngIf="source == 'calendarEvent' ">
                                <ng-container *ngIf="enableDownload">
                                    <span class="p-chips-token-label cursor-pointer"
                                        (click)="downloadFile2(attachment.attachment.name, attachment.attachment.content)">
                                        {{ attachment.attachment.name }}
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="!enableDownload">
                                    <span class="p-chips-token-label">
                                        {{ attachment.attachment.name }}
                                    </span>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="source != 'calendarEvent' ">
                                <ng-container *ngIf="enableDownload">
                                    <span class="p-chips-token-label cursor-pointer" tooltipPosition="top" [pTooltip]="attachment.attachment.name"
                                        (click)="download(attachment.attachment.location, attachment.attachment.name)">
                                        {{ attachment.attachment.name | shorten:27 }}.{{ attachment.attachment.extension }}
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="!enableDownload">
                                    <span class="p-chips-token-label" tooltipPosition="top" [pTooltip]="attachment.attachment.name">
                                        {{ attachment.attachment.name | shorten:27 }}.{{ attachment.attachment.extension }}
                                    </span>
                                </ng-container>
                            </ng-container>
                            
                            <span *ngIf="showRemove" (click)="remove(i)" class="p-chips-token-icon pi pi-times-circle">
                            </span>
                        </li>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ul>
    </div>
</div>
